// extracted by mini-css-extract-plugin
export default {"item":"item--tapFxsQFTD","active":"active--UYKBvMNFsA","icon":"icon--m6UOqx2roB"};